// AUTO-ESTRATTO da Bilancio.jsx (refactor strutturale Fase 10.03) — nessun cambio di logica/UI/testid.
export const PRIZE_LABELS_IT = {
    nl_positions: "Premi piazzamento NL (1°–14°)",
    promotion_bonus: "Bonus promozione (9 sq.)",
    tv_rights_nl: "Diritti TV NL (TOP/DOP/OPS)",
    tv_rights_cl: "Diritti TV Champions League",
    tv_rights_el: "Diritti TV Europa League",
    cl_prizes: "Premi Champions League",
    el_prizes: "Premi Europa League",
    cf_prizes: "Premi Conference League",
    league_cup_prizes: "Premi Coppa di Lega (× 4 naz.)",
    supercup_prizes: "Premi Supercoppa (× 4 naz.)",
    fair_play: "Premio Fair Play",
    individual_awards: "Premi individuali (Pallone d'Oro, MVP)",
    primavera: "Contributo Primavera",
    other: "Altri premi",
};


export function formatMlnTight(v) {
    if (v == null) return "—";
    const n = v / 1_000_000;
    if (Math.abs(n) >= 1000) return `${(n / 1000).toFixed(1)}mld`;
    if (Math.abs(n) >= 100) return `${n.toFixed(0)}mln`;
    return `${n.toFixed(1)}mln`;
}

export function StipendBox({ label, value, color, hint, bold, signed }) {
    const v = value || 0;
    const sign = signed && v > 0 ? "+" : "";
    return (
        <div className="border border-t22252a p-2.5">
            <div className="op-mono text-[9px] text-t8f95a3 uppercase">{label}</div>
            <div className={`op-mono ${bold ? "text-base font-bold" : "text-sm"} mt-1`} style={{ color }}>
                {sign}{formatMlnTight(v)}
            </div>
            {hint && <div className="op-mono text-[9px] text-t5c6370 mt-0.5">{hint}</div>}
        </div>
    );
}


export function ModalShell({ onClose, title, testid, children, wide }) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-testid={testid}>
            <div onClick={(e) => e.stopPropagation()} className={`op-card w-full ${wide ? "max-w-5xl" : "max-w-md"} p-5`}>
                <div className="op-heading text-2xl mb-3">{title}</div>
                {children}
            </div>
        </div>
    );
}
export function Field({ label, children }) {
    return <div><label className="op-label block mb-1">{label}</label>{children}</div>;
}
export function Alert({ text }) {
    return <div className="border border-tff3b30 bg-tff3b30/10 text-tff3b30 text-sm p-2">{text}</div>;
}
export function Buttons({ busy, onClose, submitTestid }) {
    return (
        <div className="flex gap-2 pt-2">
            <button type="submit" disabled={busy} className="op-btn op-btn-primary text-xs disabled:opacity-50" data-testid={submitTestid}>
                {busy ? "Salvataggio…" : "Salva"}
            </button>
            <button type="button" onClick={onClose} className="op-btn op-btn-ghost text-xs">Annulla</button>
        </div>
    );
}

export function formatMln(v) {
    if (v == null) return "—";
    if (v === 0) return "0";
    const n = v / 1_000_000;
    if (Math.abs(n) >= 100) return `${n.toFixed(0)}mln`;
    return `${n.toFixed(2)}mln`;
}
export function formatMlnShort(v) {
    if (v == null) return "—";
    const n = v / 1_000_000;
    return `${n.toFixed(1)}`;
}

